import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { Button } from 'antd';
import { FileExcelOutlined } from '@ant-design/icons';
import moment from 'moment';

export const ExportReportsVotes = ({ projects }) => {
    const exportToExcel = () => {
        const simplifiedData = [];

        projects.forEach((zonaObj) => {
            zonaObj.budgetParticipatoryDtos.forEach((proj) => {
                simplifiedData.push({
                    zona: zonaObj.zona === '99999' ? 'GENERAL' : zonaObj.zona,
                    proyecto: proj.projectName,
                    votos: proj.votes
                });
            });
        });

        const worksheet = XLSX.utils.json_to_sheet(simplifiedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Resultados');

        // Ajuste de ancho de columna automático
        const colWidths = Object.keys(simplifiedData[0]).map((key) => {
            const maxLength = Math.max(
                key.length, // encabezado
                ...simplifiedData.map((item) => item[key]?.toString().length || 0)
            );
            return { wch: maxLength + 5 }; // +5 para margen extra visual
        });
        worksheet['!cols'] = colWidths;

        const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([wbout], { type: 'application/octet-stream' });
        saveAs(blob, `Resultados_Votacion_PP_${moment().format('DD_MM_YYYY')}.xlsx`);
    };

    return (
        <Button
            style={{ marginTop: '60px' }}
            icon={<FileExcelOutlined />}
            type="link"
            onClick={exportToExcel}
        >
            Exportar resultados
        </Button>
    );
};
